import { render, staticRenderFns } from "./TradingListCalendar.vue?vue&type=template&id=dde0a7e8&scoped=true&"
import script from "./TradingListCalendar.vue?vue&type=script&lang=js&"
export * from "./TradingListCalendar.vue?vue&type=script&lang=js&"
import style0 from "./TradingListCalendar.vue?vue&type=style&index=0&id=dde0a7e8&lang=scss&scoped=true&"
import style1 from "./TradingListCalendar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde0a7e8",
  null
  
)

export default component.exports